import { render } from "./ServiceGrid.vue?vue&type=template&id=b86e9874&scoped=true"
import script from "./ServiceGrid.vue?vue&type=script&lang=js"
export * from "./ServiceGrid.vue?vue&type=script&lang=js"

import "./ServiceGrid.vue?vue&type=style&index=0&id=b86e9874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b86e9874"]])

export default __exports__